'use strict';

var BookingsIntakeModalDirective = function BookingsIntakeModalDirective($log, Chart, bookingsIntakeFieldUtils) {
  return {
    restrict: 'E',
    replace: true,
    template: require('../templates/bookings-intake-modal.html'),
    controller: 'BookingsIntakeModalController',
    scope: {
      screen: '@'
    },
    link: function link($scope, element) {
      var chartElement = element.find('.chart-container');
      var jqxGridElement = element.find('[jqx-settings]');
      var chart = new Chart(chartElement, $scope.chartFormatters);
      jqxGridElement.on('cellbeginedit', function () {
        $scope.onCellEdit();
        $scope.$apply();
      });
      $scope.renderChartDataPresent = function (data) {
        chart.render(data);
      };
      $scope.runValidation = function () {
        $scope.gridSettings.jqxGrid('begincelledit');
      };
      $scope.isValidationMessage = function () {
        var validationMessageCssDisplay = element.find('.jqx-grid-validation').css('display');
        return validationMessageCssDisplay && validationMessageCssDisplay !== 'none';
      };
      $scope.closeEditing = function () {
        $scope.gridSettings.jqxGrid('endcelledit');
      };
      $scope.closeModal = function () {
        $scope.closeEditing();
        $scope.modalMode = 'CU';
        element.modal('hide');
      };
      $scope.$on('grid:cellclick', function (event, gridEvent, rowData, gridId) {
        bookingsIntakeFieldUtils.setFieldName(gridEvent.args.datafield);
        if (bookingsIntakeFieldUtils.getFieldName() && rowData[bookingsIntakeFieldUtils.getDataFieldName()]) {
          element.modal('show');
          $scope.handleGridCellClick(rowData, gridId);
          $log.metric($scope.sourceGridId, 1, 'bookings-intake');
        }
      });
    }
  };
};
BookingsIntakeModalDirective.$inject = ['$log', 'BookingsIntakeChart', 'BookingsIntakeModalFieldUtilService', 'FeatureToggleService'];
module.exports = BookingsIntakeModalDirective;